import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import { useMemo } from 'react'
import type { OrganizationRiskSetting } from '../types/resourceExplorer'
import { RiskIndexType } from '../types/resourceExplorer'
import { ONE_MINUTE_MS } from '@app/src/wf-constants'

interface RiskTypeOption {
  label: string
  value: number
}

const useActiveRiskIndexByType = () => {
  const { data, isLoading } = useFetchResource<OrganizationRiskSetting[]>({
    key: FetchKey.OrganizationRiskSettings,
    endpoint: endpoints.organizationRiskSettings,
    options: {
      staleTime: ONE_MINUTE_MS,
    },
  })

  const countryOptions = useMemo(() => {
    if (isLoading || !data) {
      return []
    }

    return data
      .filter(setting => setting.isActivated && setting.riskType.riskIndexType === RiskIndexType.Country)
      .map(
        (setting): RiskTypeOption => ({
          label: setting.riskType.name,
          value: setting.riskType.id,
        }),
      )
  }, [data, isLoading])

  const industryOptions = useMemo(() => {
    if (isLoading || !data) {
      return []
    }

    return data
      .filter(setting => setting.isActivated && setting.riskType.riskIndexType === RiskIndexType.Industry)
      .map(
        (setting): RiskTypeOption => ({
          label: setting.riskType.name,
          value: setting.riskType.id,
        }),
      )
  }, [data, isLoading])

  return {
    countryOptions,
    industryOptions,
    isLoading,
  }
}

export default useActiveRiskIndexByType
